import { motion, AnimatePresence } from "framer-motion";
import {
  Center,
  Text,
  Input,
  Tooltip,
  Group,
  Flex,
  PasswordInput,
} from "@mantine/core";
import { IconKey, IconUser, IconAlertCircle } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { notifications } from "@mantine/notifications";

function Component(props: any) {
  const queryArgs = new URLSearchParams(window.location.search);
  const [isCapsLockOn, setCapsLockOn] = useState(false);
  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (!e.getModifierState) return;
      if (e.getModifierState("CapsLock")) {
        setCapsLockOn(true);
      } else {
        setCapsLockOn(false);
      }
    });
  }, []);
  return (
    <>
      <Center>
        <Text size="xl">
          {queryArgs.get("stage") === "signin"
            ? "Enter your private username."
            : "Specify a private username."}{" "}
          This username will only be viewable by you.
        </Text>
      </Center>
      <Center>
        <Text mt="xl" size="xl" weight="bold">
          Your private username is case sensitive.
        </Text>
      </Center>
      <Center>
        <PasswordInput
          autoFocus
          value={props.privateUsername}
          style={{ width: 400 }}
          mt="xl"
          size="xl"
          description={isCapsLockOn ? "Caps Lock is on." : ""}
          icon={<IconUser scale={50} />}
          placeholder="Private Username"
          onChange={(e: any) => {
            props.setPrivateUsername(e.currentTarget.value);
          }}
          onKeyDown={(e: any) => {
            if (e.key === "Enter") {
              if (
                props.privateUsernameHint.length === 0 &&
                queryArgs.get("stage") === "register"
              ) {
                return;
              }
              props.paginate(1);
            }
            document.dispatchEvent(new UIEvent("keydown"));
          }}
          rightSection={
            <Tooltip label="This is private" position="top-end" withArrow>
              <div>
                <IconAlertCircle
                  size={18}
                  style={{ display: "block", opacity: 0.5 }}
                />
              </div>
            </Tooltip>
          }
        />
      </Center>
      <Center>
        <Text size="xs">This field is case sensitive</Text>
      </Center>
      {queryArgs.get("stage") === "signin" && (
        <Center mt="xs">
          <Text
            color="blue"
            style={{ cursor: "pointer" }}
            onClick={async () => {
              await fetch("/email-hints?email=" + props.publicUsername);
              notifications.show({
                title: "Hints sent",
                message: "If you saved hints, we will email them to you now.",
                color: "green",
              });
            }}
          >
            Get private username hint
          </Text>
        </Center>
      )}
      {queryArgs.get("stage") === "register" && (
        <>
          <Center>
            <Text mt="xl" size="md" weight="bold">
              Hint for your private username
            </Text>
          </Center>
          <Center>
            <Input
              value={props.privateUsernameHint}
              mt="xl"
              size="md"
              icon={<IconUser scale={50} />}
              placeholder="Hint for Private Username"
              onChange={(e: any) =>
                props.setPrivateUsernameHint(e.currentTarget.value)
              }
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  if (props.privateUsername.length === 0) {
                    return;
                  }
                  props.paginate(1);
                }
              }}
              rightSection={
                <Tooltip
                  label='eg.
              "My username on AOL/Myspace."'
                  position="top-end"
                  withArrow
                >
                  <div>
                    <IconAlertCircle
                      size={18}
                      style={{ display: "block", opacity: 0.5 }}
                    />
                  </div>
                </Tooltip>
              }
            />
          </Center>
        </>
      )}
    </>
  );
}

export default Component;
